import { ColumnSelectionsModel } from "../../models";

export const AuditLogsColumns: ColumnSelectionsModel[] = [
    { name: 'Who', propertyName: 'Who', isEnabled: true },
    { name: 'Role', propertyName: 'Role', isEnabled: true },
    { name: 'When', propertyName: 'When', isEnabled: true },
    { name: 'Action', propertyName: 'Action', isEnabled: true },
    { name: 'Acted Upon', propertyName: 'ActedUpon', isEnabled: true },
    { name: 'Company', propertyName: 'Company', isEnabled: true },
]